import { render, staticRenderFns } from "./PostImage.vue?vue&type=template&id=606e3f5c&scoped=true&lang=pug&"
import script from "./PostImage.vue?vue&type=script&lang=js&"
export * from "./PostImage.vue?vue&type=script&lang=js&"
import style0 from "./PostImage.vue?vue&type=style&index=0&id=606e3f5c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e3f5c",
  null
  
)

export default component.exports